import React, { useState } from 'react';
import WeddingVowsGenerator from "./WeddingVowsGenerator";
import "./App.css"; // Add CSS for global styles
import { Link } from 'react-router-dom';

const WeddingVowsContainer = () => {
  

  const currentTheme = {
      background: "#fff0f6",
      text: "#ad0045",
      hover: { background: "#ffadd2", text: "#75002c" },
    };

  return (
    <div 
      className="app-container"
      style={{
        backgroundColor: currentTheme.background,
        transition: "background-color 0.3s ease-in-out",
        minHeight: "100vh",
        padding: "20px",
      }}
    >
      <title>Wedding Vows Generator - Romantic & Custom Vows | Message Melody</title>
      <meta name="description" content="Craft the perfect wedding vows that reflect your love story. Our Wedding Vows Generator creates romantic, heartfelt, and personalized vows for your big day."/>
      <meta name="keywords" content="wedding vows, personalized vows, wedding vow generator, romantic vows, custom wedding vows, vow writing, heartfelt wedding vows"/>

      <meta property="og:title" content="Wedding Vows Generator - Personalized Romantic Vows" />
      <meta property="og:description" content="Generate heartfelt and customized wedding vows tailored to your unique love story. Perfect for your special day." />
      <meta property="og:image" content="https://messagemelody.com/message-melody.jpg" />
      <meta property="og:url" content="https://messagemelody.com/wedding-vows-generator" />


      <div
        style={{
          textAlign: "center",
          color: currentTheme.text,
          fontSize: "24px",
          fontWeight: "bold",
          marginBottom: "10px",
        }}
      >
        <h1>Wedding Vows Generator</h1>
        <p>Write personalized wedding vows effortlessly.</p>
      </div>
      <div
        style={{
          textAlign: "center",
          color: "#333",
          fontSize: "18px",
          fontWeight: "normal",
          marginBottom: "20px",
        }}
      >
        Switch to {' '} <Link to="/" style={{ color: currentTheme.text, textDecoration: 'underline' }}>
          Messages/Poems
        </Link>.
      </div>
      <div className="feature-container">
        <WeddingVowsGenerator />
      </div>
    </div>
  );
};

export default WeddingVowsContainer;
